module.exports = __webpack_public_path__ + "img/VTS_Perform_White.1d3e3b78.svg";